/** preload image file */
export function preloadImg(url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.style.display = 'none';
        img.onload = function () {
            document.body.removeChild(img);
            resolve();
        };
        img.onerror = function () {
            document.body.removeChild(img);
            reject();
        };
        img.src = url;
        document.body.appendChild(img);
    });
}
